import { sendHTTPRequest } from '@/util/http'
import { toolkitUrls } from '@/util/links'
import { Goal } from './goal_types'

export async function getGoalByUUID(uuid: string, params: Record<string, string | number | boolean> = {}): Promise<Goal> {
  try {
    const response = await sendHTTPRequest({
      url: `${toolkitUrls.api}/goal/${uuid}`,
      method: 'GET',
      urlParams: params as Record<string, string>,
      includeCredentials: true
    })
    return await response.json() as Goal
  } catch (e) {
    throw new Error('Error getting goal by UUID', { cause: e })
  }
}
